(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AT3-product-recomendation"] && !Shopify.designMode) return;
  try {
    
const handleIntersection = (entries, observer) => {
	const html = document.createElement('div');
	const recommendations = document.querySelector('.product-recommendations');

    if (!entries[0].isIntersecting || !recommendations) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
    .then(response => response.text())
    .then(text => {
		if (text == '') {
			document.querySelector('.home-section--product-recommendations').style.display = 'none';
		}else{
			productRecommendationsSection.innerHTML = text;
		}
    })
    .catch(e => {
        console.error(e);
    });
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
